import { Component, CSSProperties } from "react";
import { Button, TextField, Snackbar } from "@mui/material";
import MuiAlert from "@mui/lab/Alert";

import KeytchensActionCreator from "../../controller/action/KeytchensActionCreator";
import KeytchensStore from "../../controller/store/KeytchensStore";

import keytchensLogo from "../../assets/images/keytchens_logo.png";
import LoadingComponent from "../utils/LoadingComponent";
import Service from "../../controller/model/service/Service";
import PopinaStore from "../../controller/store/PopinaStore";
import { ALERT_SEVERITY } from "../../controller/constant/ActionConstant";

interface StateInterface {
  service: Service;
  isReady: boolean;
  showAlert: boolean;
  message: string | undefined;
  alertSeverity: "success" | "info" | "warning" | "error";
  companyUuid: string;
}

const _updateState = () => {
  return {
    service: KeytchensStore.service
  };
};

const rootStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  textAlign: "center"
};

const imgStyle = (): CSSProperties => {
  return {
    width: "300px",
    margin: "auto"
  };
};

class KeytchensContainer extends Component<any, StateInterface> {
  constructor(props: any) {
    super(props);
    this.state = {
      service: KeytchensStore.service,
      isReady: false,
      showAlert: false,
      message: undefined,
      alertSeverity: "info",
      companyUuid: ""
    };
  }

  _handleStateChange = () => {
    this.setState(_updateState());
  };

  componentDidMount() {
    KeytchensStore.addChangeListener(this._handleStateChange);
    PopinaStore.addChangeListener(this._handleStateChange);

    KeytchensActionCreator.loadService()
      .catch((err: any) => {
        console.warn(err);
        this.setState({
          showAlert: true,
          alertSeverity: ALERT_SEVERITY.error,
          message: "Error lors de la récupération des infos Keytchens"
        });
      })
      .finally(() => {
        this.setState({ isReady: true });
      });
  }

  _handleTapConnectButton = () => {
    KeytchensActionCreator.connectService(
      this.state.companyUuid,
    )
      .catch(err => {
        console.warn(err);
        this.setState({
          showAlert: true,
          alertSeverity: ALERT_SEVERITY.error,
          message: "Erreur de connexion, uuid du restaurant est incorrect"
        });
      })
      .finally(() => {
        this.setState({ isReady: true });
      });
  };

  _handleTapDisconnectButton = () => {
    KeytchensActionCreator.disconnectService().catch((err: any) => {
      console.warn(err);
      this.setState({
        showAlert: true,
        alertSeverity: ALERT_SEVERITY.error,
        message: "Erreur lors de la déconnexion, veuillez réessayer"
      })
    }).finally(() => {
      this.setState({companyUuid: ""});
    });
  };

  _handleCloseSnackBar = () => {
    this.setState({ showAlert: false });
  };

  _handleInputChange = (e: any) => {
    this.setState({companyUuid: e.target.value});
  };

  render() {
    return (
      <div style={rootStyle}>
        <Snackbar
          open={this.state.showAlert}
          autoHideDuration={6000}
          onClose={this._handleCloseSnackBar}
        >
          <MuiAlert
            severity={this.state.alertSeverity}
            onClose={this._handleCloseSnackBar}
          >
            {this.state.message}
          </MuiAlert>
        </Snackbar>
        {this.state.isReady ? (
          <>
            {!this.state.service.isActive ? (
              <div
                style={{
                  height: "100%",
                  textAlign: "center",
                  margin: "20px",
                  backgroundColor: "#f2f2f2",
                  border: "1px solid #e1e1e1",
                  borderRadius: "6px"
                }}
              >
                <div style={{ marginTop: "30px", width: "100%" }}>
                  <img src={keytchensLogo} style={imgStyle()} alt="keytchens" />
                  <div
                    style={{
                      maxWidth: "400px",
                      margin: "auto",
                      marginTop: "10px"
                    }}
                  >
                      <TextField
                        id="companyUuid"
                        size="small"
                        label="Uuid du compagnie"
                        fullWidth={true}
                        variant="outlined"
                        onChange={this._handleInputChange}
                      />
                    <div style={{ marginTop: "10px", padding: "20px" }}>
                    <a className="keytchens_link" target="_blank" rel="noreferrer" href="https://keytchens.app/"> Aller à Keytchens </a>
                      <Button
                        variant="contained"
                        onClick={this._handleTapConnectButton}
                        style={{
                          color: "white",
                          backgroundColor: "#e93f22"
                        }}
                        color="secondary"
                      >
                        Connexion
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={rootStyle}>
                <div
                  style={{
                    padding: "30px 0px",
                    margin: "20px",
                    backgroundColor: "#f2f2f2",
                    border: "1px solid #e1e1e1",
                    borderRadius: "6px"
                  }}
                >
                  <img src={keytchensLogo} style={imgStyle()} alt="keytchens" />
                  <div>
                    <h3>Vous êtes actuellement connecté à Keytchens</h3>
                  </div>
                  <div>
                  <a className="keytchens_link" target="_blank" rel="noreferrer" href="https://keytchens.app/"> Aller à Keytchens </a>
                    <Button
                      color="secondary"
                      variant="outlined"
                      style={{
                        color: "#e93f22",
                        borderColor: "#e93f22"
                      }}
                      onClick={this._handleTapDisconnectButton}
                    >
                      Déconnexion
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div style={rootStyle}>
            <LoadingComponent isOpen={this.state.isReady} />
          </div>
        )}
      </div>
    );
  }
}

export default KeytchensContainer;
